// Components
import { Dropzone_s } from "components/import-export/import-styles"
import ConfirmationModal from "components/modal/confirmation-modal"
import OverlaySpinner from 'components/spinner/overlay-spinner'
// Data
import importService from "data/import"
// Icons
import { CloseIcon } from "images/icons/general/"
import { UploadFileIcon } from "images/icons/tools/"
import React, { FC, useCallback, useEffect, useState } from 'react'
import { useDropzone } from 'react-dropzone'
import Isvg from 'react-inlinesvg'
// Styles
import { Button_s } from "styles/app-styles"

const Import: FC = () => {
  const [showValidationModal, toggleValidationModal] = useState<boolean>(false);
  const [validationMessage, updateValidationMessage] = useState<string>("");
  const [loading, updateLoading] = useState<boolean>(false);

  const onDrop = useCallback((acceptedFiles) => {
    importService.uploadFiles(acceptedFiles[0], false);
  }, [])
  const {getRootProps, getInputProps} = useDropzone({onDrop})

  useEffect(() => {
    importService.stream().subscribe(obj => {
      if ( obj['validateResponse']){
        updateValidationMessage(obj['validateResponse']);
      }
      toggleValidationModal(obj['validateConfirmVisible'])
    });
  }, [showValidationModal, validationMessage]);

  useEffect(()=>{
    importService.stream().subscribe(obj => {
      updateLoading(obj['loading']);
    });
  }, [loading]);

  return (
    <div>
      <Dropzone_s {...getRootProps()}>
        <div>
          <span>Upload File</span>
          <a onClick={(e) => { e.stopPropagation(); importService.cancelImport() }}><Isvg src={CloseIcon} /></a>
        </div>
        <div>
          <input {...getInputProps()} />
          <Isvg src={UploadFileIcon} />
          { window.location.href.endsWith('import-export') ? <p>Drag and drop your file or click here to upload (.xls or .xlsx files only)</p> : <p>Drag and drop your file or click here to upload (.zip, .mdb, .xls or .xlsx files only)</p> }
          <Button_s primary>Browse and Upload</Button_s>
          <Button_s onClick={(e) => { e.stopPropagation(); importService.cancelImport() }}>Cancel</Button_s>
        </div>
      </Dropzone_s>

    { loading && <OverlaySpinner /> }

      <ConfirmationModal
        show={showValidationModal}
        toggleShow={toggleValidationModal}
        title={'Import Information'}
        confirmText={'Continue Import'}
        confirmFunc={()=>importService.importCb()}
        cancelFunc={()=>importService.cancelImport()}
        message={validationMessage}
        confirmOnly={false}
        closeOnly={false}
      />
    </div>
  )
}

export default Import